import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  (theme) => ({
    root: (props) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      ...props?.style?.root,
    }),
    item: (props) => ({
      display: 'flex',
      gap: '12px',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      ...props?.style?.item,
    }),
    icon: (props) => ({
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      fontSize: '16px',
      lineHeight: '16px',
      padding: '2px',
      width: '22px',
      height: '22px',
      borderRadius: '5px',
      fontWeight: theme.fontWeights.medium,
      cursor: 'default',
      color: 'black',
      ...props?.style?.icon,
    }),
    number: (props) => ({
      width: '24px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.colors.smoke,
      border: `1px solid ${theme.colors.shark}`,
      borderRadius: '24px',
      flexShrink: 0,
      ...props?.style?.number,
    }),
  }),
  { name: 'List' },
);

export default useStyles;
